import { CollectionHexLinksOrderBy } from "@hex/common";

export const COLLECTION_HEX_LINKS_PER_REQUEST = 30;
export const DEFAULT_COLLECTION_HEX_LINK_SORT_ORDER: CollectionHexLinksOrderBy =
  [{ attribute: "LAST_EDIT", direction: "DESC" }];
